<template>
  <div>
    <HealthInsuranceProviderBenefitsListContent
      v-if="insuranceCompanies.publicInsuranceCompanies.length"
      :title="$t('healthInsuranceProviderBenefits.publicInsuranceProviders')"
      :insurance-companies="insuranceCompanies.publicInsuranceCompanies"
    />
    <HealthInsuranceProviderBenefitsListContent
      v-if="insuranceCompanies.privateInsuranceCompanies.length"
      class="mt-6"
      :title="$t('healthInsuranceProviderBenefits.privateInsuranceProviders')"
      :insurance-companies="insuranceCompanies.privateInsuranceCompanies"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HealthInsuranceProviderBenefitsListContent from './HealthInsuranceProviderBenefitsListContent';

export default {
  name: 'HealthInsuranceProviderBenefitsListHolder',
  components: { HealthInsuranceProviderBenefitsListContent },
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      tab: 0
    };
  },
  computed: {
    ...mapGetters({
      insuranceCompanyList: 'forms/insuranceCompany/insuranceCompanyList'
    }),
    insuranceCompanies() {
      return {
        publicInsuranceCompanies: this.insuranceCompanyList.filter(
          val =>
            val.additionalInfo.type === 'public' &&
            val.additionalInfo.countryCode === this.$domainRegion.toUpperCase() &&
            val.additionalInfo.slug !== 'samoplatce'
        ),
        privateInsuranceCompanies: this.insuranceCompanyList.filter(
          val =>
            val.additionalInfo.type === 'private' &&
            val.additionalInfo.countryCode === this.$domainRegion.toUpperCase() &&
            val.additionalInfo.slug !== 'samoplatce'
        )
      };
    }
  }
};
</script>
